import { lazy } from "react";
import { Entry } from '../../pages/entry/Entry.Page';
import { PrivateRoute } from '../../components/PrivateRoute.Component';
import { Home } from '../../pages/home/Home.Page';
// import { Dashboard } from '../../pages/dashboard/Dashboard';
import { Masters } from '../../pages/masters/Masters';
import { Transactions } from '../../pages/transactions/Transactions';
import { Reports } from '../../pages/reports/Reports';
import { Communication } from '../../pages/communication/Communication';
import { Notification } from "../../pages/notifications/Notification.Page";
import FuelReport from "../../pages/reports/fuelReport/FuelReport";
import PurchaseOrderReport from "../../pages/reports/purchaseOrderReport/PurchaseOrderReport";
import PurchaseInvoiceReport from "../../pages/reports/purchaseInvoiceReport/PurchaseInvoiceReport";
import ItemIssueRegisterReport from "../../pages/reports/itemIssueRegisterReport/ItemIssueRegisterReport";
import SrNoWiseItemHistory from "../../pages/reports/srNoWiseItemHistory/SrNoWiseItemHistory";
import TyreReport from "../../pages/reports/tyreReport/TyreReport";
import RepairReport from "../../pages/reports/repairReport/RepairReport";

const Dashboard = lazy(() => import("../../pages/dashboard/Dashboard"));
const User = lazy(() => import("../../pages/masters/user/User"));
const Category = lazy(() => import("../../pages/masters/category/Category"));
const Brand = lazy(() => import("../../pages/masters/brand/Brand"));
const Item = lazy(() => import("../../pages/masters/item/Item"));
const Task = lazy(() => import("../../pages/masters/task/Task"));
const StaffDesignation = lazy(() => import("../../pages/masters/staffDesignation/StaffDesignation"));
const Staff = lazy(() => import("../../pages/masters/staff/Staff"));
const Store = lazy(() => import("../../pages/masters/store/Store"));
const Vendor = lazy(() => import("../../pages/masters/vendor/Vendor"));
const Battery = lazy(() => import("../../pages/masters/battery/Battery"));
const ServiceTask = lazy(() => import("../../pages/masters/serviceTask/ServiceTask"));
const Fuel = lazy(() => import("../../pages/masters/fuel/Fuel"));
const VehicleBranchMapping = lazy(() => import("../../pages/masters/vehicleBranchMapping/VehicleBranchMapping"));
const RepairItemConfig = lazy(() => import("../../pages/masters/repairItemConfig/RepairItemConfig"));
const CompanyPOTNCForm = lazy(() => import("../../pages/masters/companyPOTNC/CompanyPOTNCForm"));
const InventoryThresholdRules = lazy(() => import("../../pages/masters/inventoryThresholdRules/inventoryThresholdRules"));

const JobCards = lazy(() => import("../../pages/transactions/jobCards/JobCards"));
const IssueInventory = lazy(() => import("../../pages/transactions/issueInventory/IssueInventory"));
const ServiceCalender = lazy(() => import("../../pages/transactions/serviceCalender/ServiceCalender"));
const PurchaseOrder = lazy(() => import("../../pages/transactions/purchaseOrder/PurchaseOrder"));
const PurchaseInvoice = lazy(() => import("../../pages/transactions/purchaseInvoice/PurchaseInvoice"));
const InventoryTransfer = lazy(() => import("../../pages/transactions/inventoryTransfer/InventoryTransfer"));
const ExternalTransferRepair = lazy(() => import("../../pages/transactions/inventoryTransfer/externalTransferRepair/ExternalTransferRepair"));
const FuelVoucher = lazy(() => import("../../pages/transactions/fuelVoucher/FuelVoucher"))
const ProcessVoucher = lazy(() => import("../../pages/transactions/processVoucher/ProcessVoucher"))
const PurchaseReturn = lazy(() => import("../../pages/transactions/purchaseReturn/PurchaseReturn"))

const ClosingStockSummary = lazy(() => import("../../pages/reports/closingStockSummary/ClosingStockSummary"));
const ItemTransactionReport = lazy(() => import("../../pages/reports/itemTransactionReport/ItemTransactionReport"));
const VehiclewiseConsumptionReport = lazy(() => import("../../pages/reports/vehiclewiseConsumptionReport/VehiclewiseConsumptionReport"));
const VehiclewiseConsumptionQuickViewReport = lazy(() => import("../../pages/reports/vehiclewiseConsumptionQuickViewReport/VehiclewiseConsumptionQuickViewReport"));
const JobCardReport = lazy(() => import("../../pages/reports/jobCardReport/JobCardReport"));
const JobCardTask = lazy(() => import("../../pages/reports/jobCardTask/jobCardTask"));
const BatteryReport = lazy(() => import("../../pages/reports/battery-report/BatteryReport"));


const SmsHomePage = lazy(() => import("../../pages/communication/sms/SmsHomePage"))
const WhatsappHomePage = lazy(() => import("../../pages/communication/whatsapp/WhatsappHomePage"))

export const routes = [
    { path: "/login", element: <Entry /> },
    {
        path: "/", element:
            <PrivateRoute>
                <Home />
            </PrivateRoute>
        , children: [
            { path: "/dashboard", element: <Dashboard /> },
            {
                path: "/masters",
                element: <Masters />,
                children: [
                    { path: "/masters/user", element: <User /> },
                    { path: "/masters/category", element: <Category /> },
                    { path: "/masters/brand", element: <Brand /> },
                    { path: "/masters/item", element: <Item /> },
                    { path: "/masters/task", element: <Task /> },
                    { path: "/masters/staff-designation", element: <StaffDesignation /> },
                    { path: "/masters/staff", element: <Staff /> },
                    { path: "/masters/store", element: <Store /> },
                    { path: "/masters/vendor", element: <Vendor /> },
                    { path: "/masters/battery", element: <Battery /> },
                    { path: "/masters/service-task", element: <ServiceTask /> },
                    { path: "/masters/fuel", element: <Fuel /> },
                    { path: "/masters/vehicle-branch-mapping", element: <VehicleBranchMapping /> },
                    { path: "/masters/repair-item-config", element: <RepairItemConfig /> },
                    { path: "/masters/company-po-tnc", element: <CompanyPOTNCForm /> },
                    { path: "/masters/inventory-threshold-rules", element: <InventoryThresholdRules /> },
                ],
            },
            {
                path: "/transactions",
                element: <Transactions />,
                children: [
                    { path: "/transactions/job-cards", element: <JobCards /> },
                    { path: "/transactions/issue-inventory", element: <IssueInventory /> },
                    { path: "/transactions/purchase-order", element: <PurchaseOrder /> },
                    { path: "/transactions/purchase-invoice", element: <PurchaseInvoice /> },
                    { path: "/transactions/serviceCalender", element: <ServiceCalender /> },
                    { path: "/transactions/inventory-transfer", element: <InventoryTransfer /> },
                    { path: "/transactions/external-transfer-repair", element: <ExternalTransferRepair /> },
                    { path: "/transactions/fuelVoucher", element: <FuelVoucher /> },
                    { path: "/transactions/purchaseReturn", element: <PurchaseReturn /> },
                    { path: "/transactions/processVoucher", element: <ProcessVoucher /> },
                ]
            },
            {
                path: "/reports", element: <Reports />,
                children: [
                    { path: "/reports/closing-stock-summary", element: <ClosingStockSummary /> },
                    { path: "/reports/item-transaction-log", element: <ItemTransactionReport /> },
                    { path: "/reports/vehiclewise-consumption-report", element: <VehiclewiseConsumptionReport /> },
                    { path: "/reports/vehiclewise-consumption-quick-view-report", element: <VehiclewiseConsumptionQuickViewReport /> },
                    { path: "/reports/job-card-report", element: <JobCardReport /> },
                    { path: "/reports/job-card-task", element: <JobCardTask /> },
                    { path: "/reports/battery-report", element: <BatteryReport /> },
                    { path: "/reports/fuel-report", element: <FuelReport /> },
                    { path: "/reports/purchaseorder-report", element: <PurchaseOrderReport /> },
                    { path: "/reports/purchaseinvoice-report", element: <PurchaseInvoiceReport /> },
                    { path: "/reports/itemissueregister-report", element: <ItemIssueRegisterReport /> },
                    { path: "/reports/srno-wise-item-history", element: <SrNoWiseItemHistory /> },
                    { path: "/reports/tyre-report", element: <TyreReport /> },
                    { path: "/reports/repair-report", element: <RepairReport /> },
                ]
            },
            {
                path: "/communication", element: <Communication />,
                children: [
                    { path: "/communication/sms", element: <SmsHomePage /> },
                    { path: "/communication/whatsapp", element: <WhatsappHomePage /> },
                ]
            },
            {
                path: "/configs", element: <User />,
                children: [
                    { path: "/configs/job-card-config", element: <User /> },
                    { path: "/configs/purchase-config", element: <Category /> },
                ]
            },
        ]
    },
    { path: "/notifications", element: <Notification /> },
];